const espaceUserMenuMobile = () => {
    const espaceUserTitles = document.querySelectorAll(".espace-user-mobile-menu-title");
    const espaceUserParts = document.querySelectorAll(".espace-user-mobile-part");
    const espaceUserReturnBtns = document.querySelectorAll(".espace-user-return-button");
    const espaceUserMenu = document.querySelector(".espace-user-mobile-menu")
    let index = 0;

    if (espaceUserTitles) {
        espaceUserTitles.forEach(espaceUserTitle => {
            espaceUserTitle.addEventListener('click', () => {
                index = espaceUserTitle.getAttribute('data-menu-user')
                espaceUserParts.forEach(espaceUserPart => {
                    if (espaceUserPart.getAttribute('data-menu-user') == index) {
                        espaceUserPart.classList.add('espace-user-mobile-active')
                        espaceUserPart.classList.remove('espace-user-mobile-inactive')
                        espaceUserMenu.classList.remove('espace-user-mobile-active')
                        espaceUserMenu.classList.add('espace-user-mobile-inactive')
                    }
                });
            });

        });
    }

    if (espaceUserReturnBtns) {
        espaceUserReturnBtns.forEach(espaceUserReturnBtn => {
            espaceUserReturnBtn.addEventListener('click', () => {
                espaceUserParts.forEach(espaceUserPart => {
                    if (espaceUserPart.classList.contains('espace-user-mobile-active')) {
                        espaceUserPart.classList.remove('espace-user-mobile-active')
                        espaceUserPart.classList.add('espace-user-mobile-inactive')
                    }
                    espaceUserMenu.classList.remove('espace-user-mobile-inactive')
                    espaceUserMenu.classList.add('espace-user-mobile-active')
                });
            });
        });

    }
}

const copyTextToClipboard = async (text) => {
  if (!text) return false

  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (_err) {
      // fallback below
    }
  }

  const textarea = document.createElement("textarea")
  textarea.value = text
  textarea.setAttribute("readonly", "")
  textarea.style.position = "fixed"
  textarea.style.top = "-9999px"
  document.body.appendChild(textarea)
  textarea.select()
  let ok = false
  try {
    ok = document.execCommand("copy")
  } catch (_err) {
    ok = false
  }
  textarea.remove()
  return ok
}

const initBadgesInviteCopy = () => {
  document.querySelectorAll("[data-badges-invite-copy]").forEach((btn) => {
    if (btn.dataset.bound === "true") return
    btn.dataset.bound = "true"

    btn.addEventListener("click", async () => {
      const text = btn.dataset.copyText || ""
      const ok = await copyTextToClipboard(text)
      if (!ok) return

      const original = btn.textContent
      btn.textContent = "Lien copié !"
      btn.disabled = true
      window.setTimeout(() => {
        btn.textContent = original
        btn.disabled = false
      }, 2000)
    })
  })
}

export { espaceUserMenuMobile, initBadgesInviteCopy };